module.exports = __webpack_public_path__ + "static/img/route.193c013.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/route.png
// module id = C9La
// module chunks = 0